import AuthService from './AuthService'
import Poll from '../models/Poll'

const ts = firebase.database.ServerValue.TIMESTAMP

export default class PollService {
	constructor() {
		this.auth = new AuthService()
		this.ref = firebase.database().ref()
		this.pollsRef = this.ref.child('polls')
		this.resultsRef = this.ref.child('results')
		this.usersRef = this.ref.child('users')
		this.votesRef = this.ref.child('votes')
	}

	create(data) {
		const pollRef = this.pollsRef.push()
		const pollKey = pollRef.key

		return this.auth.getOrCreateUser().then(({ uid }) => (
			this.ref.update({
				[`polls/${pollKey}`]: Object.assign({}, data, { ts, uid }),
				[`results/${pollKey}`]: data.options.map(() => 0),
				[`users/${uid}/polls/${pollKey}`]: ts,
			}).then(() => pollKey)
		))
	}

	remove(id) {
		const { uid } = this.auth.currentUser

		return Promise.all([
			this.votesRef.child(id).remove(),
			this.resultsRef.child(id).remove(),
			this.usersRef.child(uid).child('polls').child(id).remove(),
			this.pollsRef.child(id).remove(),
		])
	}

	listen(pollId, callback) {
		const ref = this.pollsRef.child(pollId)

		ref.off()
		ref.on('value', (snap) => callback({
			pollId,
			poll: snap.exists() ? new Poll(snap) : null,
		}))

		return () => ref.off()
	}

	update(pollId, values) {
		return this.pollsRef.child(pollId).update(values)
	}
}



// WEBPACK FOOTER //
// ./src/services/PollService.js